import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "submit"];
  static values = { required: Boolean };

  declare inputTargets: HTMLInputElement[];
  declare submitTarget: HTMLButtonElement;
  connect() {
    this.checkForm();
  }

  checkForm() {
    const allFilled = Array.from(this.inputTargets).every((input) => {
      if (input.type === "file") {
        return input.files.length > 0;
      }
      return input.value.trim() !== "";
    });

    this.submitTarget.disabled = !allFilled;
  }
}
